import { getCarBrandsUrl, getCarNumberPlateUrl } from "../../../shared/constants/apiUrls";
import { baseApi } from "./baseApi";

export const carsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCarNumberPlate: builder.query({
            query: (numberPlate) => {
                const params = new URLSearchParams({ plate: numberPlate }).toString();
                return {
                    url: `${getCarNumberPlateUrl}?${params}`,
                    method: "GET"
                };
            },

            providesTags:[{ type: "Car", id: "NUMBER_PLATE" }]
        }),
        getCarBrands: builder.query({
            query: () => ({
                url: `${getCarBrandsUrl}`,
                method: "GET"
            }),
            providesTags: [{ type: "Car", id: "BRANDS" }]
        })
    })

})

export const { 
    useLazyGetCarNumberPlateQuery,
    useGetCarBrandsQuery
} = carsApi;